import React from 'react';
import { Grid } from '@react-three/drei';
import { ThemeBanner } from '../VenueDecorations';

/**
 * The outdoor ground layer — grass carpet, asphalt event plaza,
 * pathways, subtle grid overlay and four theme banners near the
 * entrance. Recolours slightly when it's raining for atmosphere.
 * Landmarks (stadium, carpark, palms, archway) come from the DB
 * and are rendered by <LandmarkRenderer />.
 */
export function GroundPlane({ weatherCondition }) {
  const isRaining = ['rainy', 'stormy'].includes(weatherCondition);
  const groundColor = isRaining ? '#3d4650' : '#5a5a5a';
  const grassColor  = isRaining ? '#3a5f2f' : '#4a7c3a';

  return (
    <>
      {/* Grass around venue */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.1, 0]} receiveShadow>
        <planeGeometry args={[800, 800]} />
        <meshStandardMaterial color={grassColor} roughness={0.95} />
      </mesh>

      {/* Main asphalt plaza */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 25]} receiveShadow>
        <planeGeometry args={[220, 110]} />
        <meshStandardMaterial color={groundColor} roughness={0.9} />
      </mesh>

      {/* Grid overlay */}
      <Grid
        args={[220, 110]}
        cellSize={5}
        cellThickness={0.2}
        cellColor="#666666"
        sectionSize={20}
        sectionThickness={0.5}
        sectionColor="#333333"
        fadeDistance={220}
        fadeStrength={2}
        followCamera={false}
        infiniteGrid={false}
        position={[0, 0.02, 25]}
      />

      {/* Perimeter pathways */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[-85, 0.03, 0]} receiveShadow>
        <planeGeometry args={[6, 220]} />
        <meshStandardMaterial color="#7a7a7a" roughness={0.8} />
      </mesh>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.03, -48]} receiveShadow>
        <planeGeometry args={[220, 4]} />
        <meshStandardMaterial color="#8b8b8b" roughness={0.8} />
      </mesh>

      {/* Theme banners near entrance */}
      <ThemeBanner position={[-75, 0, 12]} color="#22c55e" text="HIJAU" />
      <ThemeBanner position={[-70, 0, 12]} color="#3b82f6" text="INOVASI" />
      <ThemeBanner position={[-65, 0, 12]} color="#ec4899" text="KOMUNITI" />
      <ThemeBanner position={[-60, 0, 12]} color="#f97316" text="LESTARI" />
    </>
  );
}
